// ----------------------------------------------------------------------------
// Template: Pages
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

//Scripts
import 'sections/header/header';
import 'sections/main-page/main-page';
import 'sections/callout-panel/callout-panel';
import 'sections/image-with-text/image-with-text';
import 'sections/icons-with-text/icons-with-text';
import 'sections/banner/banner';
import 'sections/faq/faq';
import 'sections/tabbed-content/tabbed-content';
import 'sections/collection-list/collection-list-carousel';
import 'sections/collection-list/collection-list-carousel-tabs';
import 'sections/announcement-bar/announcement-bar';
import 'sections/app-wrapper/app-wrapper';
import 'sections/multicolumn/multicolumn';
import 'sections/featured-collection/featured-collection-grid';
import 'sections/featured-collection-product/featured-collection-product';
import 'sections/blog-posts/blog-posts-grid';
import 'sections/email-signup/email-signup';
import 'sections/hero/hero';
import 'sections/rich-text/rich-text';
import 'sections/custom-liquid/custom-liquid';
import 'sections/video-banner/video-block';
import 'sections/product-highlight/product-highlight';
import 'sections/logo-grid/logo-grid';
import 'sections/footer/footer';
import 'sections/guarantee-bar/guarantee-bar';